import environment from '../environment/index.js';
var env = {
  get: function (isApi) {
    if (isApi === void 0) {
      isApi = false;
    }
    return isApi ? environment.getApiEnv() : environment.getEnv();
  }
};
export default env;